import convertImageToBase64 from '../../utils/converitr-imagen-base64';

export const formularioTopSlice = (set,get) => ({
    obtenerTop: () => {
        fetch("/p_top")
        .then((res) => res.json())
        .then(async(data) => {
            console.log('la datas',data);
            if(data.status === 1){
                set({ platillos: data.data[0].map((item) => { return { value: item.ID_PLA_PP, label: item.NOMBRE_PLA } }) })

                let imagenesPlatillos = []
                for(let i = 0; i < data.data[1].length; i++){
                    let laImagen = `/tops/${data.data[1][i].NOMBRE_TOP}`;
                    let base64 = await convertImageToBase64(laImagen);
                    imagenesPlatillos.push({
                        id:data.data[1][i].ID_TOP,
                        nombre:data.data[1][i].NOMBRE_TOP,
                        file:null,
                        esNuevo:false,
                        preview:base64,
                        titulo:data.data[1][i].TITULO_TOP,
                        categoria:data.data[1][i].ID_PLA_TOP,
                        sucursal:data.data[1][i].ID_SUC_TOP,
                    })
                }

                console.log('imagenesPlatillos',imagenesPlatillos);

                set({multiImagenes:imagenesPlatillos, multiImagenesTemp:imagenesPlatillos});
                set({ sucursalSelecionada: [{ value: data.data[2][0].ID_SUC, label: data.data[2][0].NOMBRE_SUCURSAL_SUC }] })
                set({ sucursales: data.data[2].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } }) })
            }
           set({isLoading:false});
        });
    },
    handleSave: () => {
        const formData = new FormData();
        let datosImagnes = []
        for(let i = 0; i < get().multiImagenesTemp.length; i++){
            let dato = get().multiImagenesTemp[i];
            if(dato.sucursal == get().sucursalSelecionada[0].value){
               if(dato.esNuevo){
                    formData.append('miArchivo', dato.file);
                }
                datosImagnes.push({
                    id_pla: dato.categoria,
                    titulo: dato.titulo,
                    nombre: dato.nombre,
                    pos: i + 1,
                }) 
            }
        }
        formData.append('datosImagenes', JSON.stringify(datosImagnes));
        formData.append('idSucursal', get().sucursalSelecionada[0].value);
        fetch("/p_top",{
        method: "POST",
        body: formData
        })
        .then((res) => res.json())
        .then((data) => {
            console.log(data);
            window.notie.alert({ type: 'success', text: 'Top registrado correctamente',  });
            /* if(data.status === 1){
                // Success
                get().elNavigate(-1);
            } */
            });
      },
    /*   obtenerPlatillo: () => {
        if(get().datos.id != 0){
            fetch("/p_platillo",{
                method: "PATCH",
                headers:{
                "Content-Type": "application/json",
                },
                body: JSON.stringify({id:get().datos.id})
            })
            .then((res) => res.json())
            .then(async (data) => {
                console.log('PLATILLO',data);
                if(data.status === 1){
                    set({datos:{
                        ...get().datos,
                        id_cp:data.data[0][0].ID_CP_PLA.toString(),
                        nombre:data.data[0][0].NOMBRE_PLA,
                        descripcion:data.data[0][0].DESCRIPCION_PLA,
                        precio:data.data[0][0].PRECIO_PP.toString(),
                        nivel_picante:data.data[0][0].NIVEL_PICANTE_PLA.toString(),
                        tiempo:data.data[0][0].TIEMPO_PREPARACION_PLA.toString(),
                        estatus:data.data[0][0].ESTATUS_PLA
                    }});
                    set({sucursalesPlatillo:data.data[1].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } })});

                    let imagenesPlatillos = []
                    for(let i = 0; i < data.data[2].length; i++){
                        let laImagen = `/platillo/${get().datos.id}/${data.data[2][i].NOMBRE_PLI}`;
                        let base64 = await convertImageToBase64(laImagen);
                        imagenesPlatillos.push({
                            id:data.data[2][i].ID_PLI,
                            nombre:data.data[2][i].NOMBRE_PLI,
                            file:null,
                            esNuevo:false,
                            preview:base64,
                        })
                    }

                    console.log('imagenesPlatillos',imagenesPlatillos);

                    set({multiImagenes:imagenesPlatillos});

                    set({isLoading:{...get().isLoading,cargarPlatillo:false}});
                }
            });
        }
        else{
            set({isLoading:{...get().isLoading,cargarPlatillo:false}});
        }
    }, */
})